import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { DropdownMenu } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { useSiteId } from '~src/main/hooks/useSiteId';
import { AppRoute } from '~src/main/routes';

import { PendingShipmentListItem } from '../queries';

interface Props {
  pendingShipment: PendingShipmentListItem;
  trigger: ReactNode;
}

export function Menu(props: Props) {
  const { pendingShipment, trigger } = props;
  const siteId = useSiteId();
  const { t } = useTranslation();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>{trigger}</DropdownMenu.Trigger>

      <DropdownMenu.Content>
        <RoleGuard roles={['transport:edit']} withTooltip>
          <DropdownMenu.Item asChild>
            <RouterLink
              to={`/${AppRoute.SITE}/${siteId}/${AppRoute.SHIPMENTS}/${AppRoute.CREATE}/${AppRoute.PENDING}/${pendingShipment?.lookup_id}`}
            >
              {t('common.createShipment')}
            </RouterLink>
          </DropdownMenu.Item>
        </RoleGuard>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
